<template>
    <div id="horizontal-list">
        <div class="new-list-wrap">
            <swiper class="swiper" :options="swiperOption">
                <template v-for="(store, index) in store_list">
                    <swiper-slide :key="index">
                        <a href="javascript:void(0)">
                            <template v-if="store.photograph_path == '/images/MOBILE/defalut.jpg'">
                                <div class="new-cafe-list"  @click="goStoreDetail(store.store_id, store.store_name)" :style="{background: 'url('+host_url+'/'+store.photograph_path+') no-repeat center center/cover', 'background-size':'60%',  'background-position-y':'90px'}">
                                    <div class="new-cafe-info">
                                        <span class="tag-new">NEW</span><br>
                                        <div class="cafe-name">{{store.store_name}}</div>
                                        <span class="cafe-location">{{store.address}}</span>
                                        <!-- <span class="cafe-length"></span>  -->
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="new-cafe-list"  @click="goStoreDetail(store.store_id, store.store_name)" :style="{background: 'url('+host_url+'/'+store.photograph_path+') no-repeat center center/cover'}">
                                    <div class="new-cafe-info">
                                        <span class="tag-new">NEW</span><br>
                                        <div class="cafe-name">{{store.store_name}}</div>
                                        <span class="cafe-location">{{store.address}}</span>
                                        <!-- <span class="cafe-length"></span>  -->
                                    </div>
                                </div>
                            </template>
                            
                        </a>
                    </swiper-slide>
                </template>
            </swiper>
        </div>
    </div>
</template>

<script>
    import * as config from '../../js/config';
    import common from '../../js/common';
    import EventBus from '../../js/event_bus';

    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import SwiperCore, { Autoplay } from 'swiper'
    import 'swiper/swiper-bundle.css'

    SwiperCore.use([Autoplay]);

    export default {
        components: {
            Swiper,
            SwiperSlide
        },
        name: "horizontal-list",
        data(){
            return {
                host_url:'',
                store_list: [],
                slidesPerView: 'auto',
                params: {},
                swiperOption: {
                    autoplay: {
                        delay: 2500,
                    },
                    breakpoints : {
                        1024: {
                            slidesPerView: 3.432,
                            spaceBetween: 15,
                        },
                        768: {
                            slidesPerView: 2.56,
                            spaceBetween: 15,
                        },
                        568: {
                            slidesPerView: 2.3,
                            spaceBetween: 15
                        },
                        414: {
                            slidesPerView: 1.712,
                            spaceBetween: 10
                        },
                        412: {
                            slidesPerView: 1.704,
                            spaceBetween: 10  
                        },
                        375: {
                            slidesPerView: 1.543,
                            spaceBetween: 10
                        },
                        320: {
                            slidesPerView: 1.559,
                            spaceBetween: 10
                        },
                        280: {
                            slidesPerView: 1.287,
                            spaceBetween: 10
                        }


                    }
                },
            }
        },
        mounted() {
            this.$nextTick(function(){
                this.host_url = config.HOST;                 
            })
        },
        methods: {
            initComponent(params){
                // this.store_list = [];
                this.params = params;
                this.getData();
            },
            getData(){
                // common.getData(
                //     config.REQ_NEW_STORE_LIST, 
                //     data, 
                //     (response) => {
                //         this.store_list = response;
                // })
                var data = this.params;
                common.getData(data.type, data, 
                    (response) => {
                        this.store_list = response;                        
                        for(let i = 0; i < this.store_list.length; i ++){
                            if(this.store_list[i].photograph_path == null){
                                this.store_list[i].photograph_path = '/images/MOBILE/defalut.jpg'
                            }
                        }                        
                })
            },
            goStoreDetail(store_id, store_name){
                this.params.store_id = store_id;
                this.params.store_name = store_name;
                common.setParams(this.params);
                EventBus.$emit('detail-data', this.params);
                this.$router.push('/detail');
            }
        }
    }
    
</script>


// WEBPACK FOOTER //
// src/components/component/HorizontalListComponent.vue